import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import WhyChooseUs from './components/WhyChooseUs';
import StatsSection from './components/StatsSection';
import LicenseSection from './components/LicenseSection';
import TeamSection from './components/TeamSection';
import CTASection from './components/CTASection';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar dark />
      <main>
        <AboutHero />
        <OurStory />
        <WhyChooseUs />
        <StatsSection />
        <LicenseSection />
        <TeamSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}